/** @format */

import Layout from '../Partials/Layout';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../shared/utils/auth/Index';
import Loader from '../../shared/components/Loader';

const Show = () => {
	const [order, setOrder] = useState(undefined);
	const { id } = useParams();

	useEffect(() => {
		fetchOrders();
	}, [id]);

	const fetchOrders = () => {
		let url = `/order/${id}`;
		api.get(
			url,
			{},
			(res) => {
				let data = res.data.data;
				setOrder(data);
			},
			(err) => {
				alert('error');
			},
		);
	};

	return order === undefined ? (
		<Layout>
			<Loader />
		</Layout>
	) : (
		<Layout>
			<div className='font-irs-b'>
				<h4 className='d-inline-block ml-4'>سفارش</h4>
			</div>
			<hr className='my-1 bold-hr' />

			<div className='row'>
				<div className='col-12 col-md-6'>
					<div className='form-group'>
						<label>نام و نام خانوادگی کاربر</label>
						<input
							type='text'
							value={order?.user?.name + ' ' + order?.user?.surname}
							className='form-control'
						/>
					</div>
				</div>
				<div className='col-12 col-md-6'>
					<div className='form-group'>
						<label>نام و نام خانوادگی تحویل گیرنده</label>
						<input
							type='text'
							value={order?.name + ' ' + order?.surname}
							className='form-control'
						/>
					</div>
				</div>
				<div className='col-12 col-md-6'>
					<div className='form-group'>
						<label> تلفن تماس تحویل گیرنده</label>
						<input type='text' value={order?.phone} className='form-control' />
					</div>
				</div>
				<div className='col-12 col-md-6'>
					<div className='form-group'>
						<label>آدرس تحویل گیرنده</label>
						<textarea
							type='text'
							value={order?.address}
							className='form-control'></textarea>
					</div>
				</div>
				<div className='col-12 col-md-6'>
					<div className='form-group'>
						<label> کدپستی تحویل گیرنده</label>
						<input
							type='text'
							value={order?.zip_code}
							className='form-control'
						/>
					</div>
				</div>
				<div className='col-12 col-md-6'>
					<div className='form-group'>
						<label>قیمت کل کتاب ها</label>
						<input
							type='text'
							value={order?.sum_price + 'تومان'}
							className='form-control'
						/>
					</div>
				</div>
				<div className='col-12 col-md-6'>
					<div className='form-group'>
						<label>هزینه ارسال</label>
						<input
							type='text'
							value={order?.delivery_price + 'تومان'}
							className='form-control'
						/>
					</div>
				</div>
				<div className='col-12 col-md-6'>
					<div className='form-group'>
						<label>قیمت کل سفارش</label>
						<input
							type='text'
							value={order?.total_price + 'تومان'}
							className='form-control'
						/>
					</div>
				</div>
				<div className='col-12'>
					<div className='d-flex flex-column'>
						<h1 className='' style={{ fontSize: '16px' }}>
							لیست کتاب ها :
						</h1>
					</div>
				</div>
				<div className='w-100 d-flex flex-column px-3'>
					{order.items?.map((item) => (
						<div className='d-flex flex-row w-100 border my-2 border-secondary rounded p-2'>
							<div className='col-12 col-md-6'>
								<div className='form-group'>
									<label>قیمت کتاب</label>
									<input
										disabled
										type='text'
										value={item.price + 'تومان'}
										className='form-control'
									/>
								</div>
								<div className='form-group'>
									<label>نام کتاب</label>
									<input
										disabled
										type='text'
										value={item.product?.name}
										className='form-control'
									/>
								</div>
								<div className='form-group'>
									<label>تعداد</label>
									<input
										type='text'
										disabled
										value={item?.qty}
										className='form-control'
									/>
								</div>
							</div>
							<div className='col-12 col-md-6 mt-5'>
								<div className='form-group'>
									<img
										src={
											'http://morabishooo.com/' +
											item.product?.images?.[0]?.path
										}
										style={{ width: '100px', height: '100px' }}
									/>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</Layout>
	);
};

export default Show;
